module.exports = __webpack_public_path__ + "img/challenge_completed.e0c3a759.png";